import React, { useEffect, useLayoutEffect, useRef, useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import Table from '../../core/common/dataTable/index'; 
import { useHeaderFilters } from '../../context/HeaderFilterContext';
import useDynamicPageSize from '../../useDynamicPageSize';
import Footer from '../../Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { toast, ToastContainer } from "react-toastify";
import nodeApi from "../../nodeApi";
import JobDescriptionField from './JobDescriptionField';
import { useParams, useNavigate } from "react-router-dom";
import { encryptQuery,decryptQuery } from "../../utils/encryption";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import CommonSelect, { Option } from "../../core/common/commonSelect";
import TextareaAutosize from 'react-textarea-autosize';
import ScheduleInterviewModal from "../interviews/ScheduleInterviewModal";

type JobOpeningType = {
  id: number;
  job_profile: string;
  job_description: string;
  required_experience_min_years: number | null;
  required_experience_max_years: number | null;
  job_location: string;
  status: string;
  deleted_at: string|null;
  created_at: string;
  updated_at: string;
};
type ModalMode = "add" | "edit";

type EmployeeFiltersProps = {
  searchTerm: string;
  onSearchTermChange: (val: string) => void;
  onAdd: () => void;
  onResetFilters: () => void;
};

const JobOpeningFilters: React.FC<EmployeeFiltersProps> = ({
  searchTerm,
  onSearchTermChange,
  onAdd,
  onResetFilters, 
}) => {
  return (
      <div className="upper-absolute-class">
        <div className="holiday-full-width">
          <div className="d-flex align-items-center gap-2 vendor-padding-right" >
          {searchTerm.trim() && (
          <button
              className="btn add_btn_size btn-outline-primary reset-vendor"
              onClick={onResetFilters}
              title="Reset"
              >
              <i className="ti ti-refresh" />
            </button>
            )}
            <div className="holiday-flex">
            <input
              type="text"
              className="form-control search-size"
              placeholder="Search…"
              value={searchTerm}
              onChange={(e) => onSearchTermChange(e.target.value)}
              style={{width:"100%"}}
            />
            </div>
            <button className="btn btn-outline-primary add_btn_size" onClick={onAdd}>
              <i className="ti ti-circle-plus" />
            </button>
          </div>
        </div>
      </div>
  );
};

// Debounce hook
function useDebounce<T>(value: T, delay = 500): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const h = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(h);
  }, [value, delay]);
  return debounced;
}

const JobOpenings: React.FC = () => {
  // Pagination state
  const { setFilters } = useHeaderFilters();
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageCandidates, setCurrentPageCandidates] = useState(1);
  const pageSize = useDynamicPageSize();
   const isInitialFetch = useRef(true);
   const [totalItems, setTotalItems] = useState<number>(0);
   const [totalItemsCandidates, setTotalItemsCandidates] = useState<number>(0);
  const [tableHeight, setTableHeight] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [loadingCandidates, setLoadingCandidates] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermCandidates, setSearchTermCandidates] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  const debouncedSearchTermCandidates = useDebounce(searchTermCandidates, 300);
  const { encryptedQuery } = useParams<{ encryptedQuery?: string }>();

useLayoutEffect(() => {
  if (pageSize === 0) return; // Prevent setting height too early
  const calculateHeight = () => {
    const baseOffset = 194;
    const extraOffset = window.innerWidth <= 991 ? -43 : -81;
    const fixedOffset = baseOffset + extraOffset;
  
    const newHeight = window.innerHeight - fixedOffset;
  
    console.log('Calculated table height:', newHeight);
    console.log('fixedOffset:', fixedOffset);
    console.log('window.innerHeight:', window.innerHeight);
    console.log("totalItems :",totalItems);
     console.log("pagesize :",pageSize);
    setTableHeight(newHeight);
  };
   calculateHeight(); 
  window.addEventListener("resize", calculateHeight); // respond to window size changes

    return () => window.removeEventListener("resize", calculateHeight); // cleanup on unmount
  }, []);

  // Data state
  const [jobOpening, setJobOpening] = useState<JobOpeningType[]>([]);
  const [candidates, setCandidates] = useState<any>([]);
  // Form state
  const [formData, setFormData] = useState<{
  job_profile: string;
  job_description: string;
  required_experience_min_years: number | null;
  required_experience_max_years: number | null;
  job_location: string;
  status: string;
}>({
  job_profile: "",
  job_description: "",
  required_experience_min_years: null,
  required_experience_max_years: null,
  job_location: "",
  status: "active",
});

  const [modalMode, setModalMode] = useState<ModalMode>("add");
  const [editId, setEditId] = useState<number | null>(null);
  const [deleteId, setDeleteId] = useState<number | null>(null);

  // Validation error state
  const [formError, setFormError] = useState<{
    job_profile?: string;
    job_description?: string;
    required_experience?: string;
    job_location?: string;
  }>({});

  const [showInterviewModal, setShowInterviewModal] = useState(false);
  const [showLoadCandidateModal, setShowLoadCandidateModal] = useState(false);
  const [interviewMode, setInterviewMode] = useState<"schedule" | "load"| "newRound">("schedule");
  const [selectedCandidate, setSelectedCandidate] = useState<any>(null);

  type Candidate = {
  id: number;
  name: string;
  email: string;
  total_experience_months: number;
  ctc_info: number;
  current_location: string;
};

const [selectedJob, setSelectedJob] = useState<JobOpeningType | null>(null);

  const fetchJobOpenings = async () => {
    try {
      setLoading(true);
      const res = await nodeApi<any>(
        `/job-openings/all-job-openings`, {
            method: 'POST',
            body: { currentPage, pageSize, searchTerm: debouncedSearchTerm || "", },
        }
      );
      console.log("Raw API response:", res);
      setJobOpening(res?.data);
      setTotalItems(res?.pagination?.totalRecords);
    } catch (err: any) {
      console.error("Fetch error:", err.message);
    } finally {
      setLoading(false);
    }
  };

  

   const fetchCandidates = async () => {
    try {
      setLoadingCandidates(true);
      const res = await nodeApi<any>(
        `/interviews/candidates`, {
            method: 'POST',
            body: { currentPage: currentPageCandidates, pageSize:12, searchTerm: debouncedSearchTermCandidates || "", },
        }
      );
      console.log("Raw API response:", res);
      setCandidates(res?.data);
      setTotalItemsCandidates(res?.pagination?.totalRecords);
    } catch (err: any) {
      console.error("Fetch error:", err.message);
    } finally {
      setLoadingCandidates(false);
    }
  };

  useEffect(() => {
  setCurrentPageCandidates(1);
}, [debouncedSearchTermCandidates]);

useEffect(() => {
  if (!showLoadCandidateModal) return;
  fetchCandidates();
}, [showLoadCandidateModal, currentPageCandidates, debouncedSearchTermCandidates]);


  useEffect(() => {
     if (isInitialFetch.current) {
      isInitialFetch.current = false;
      return;
    }
    fetchJobOpenings();
  }, [currentPage, pageSize, debouncedSearchTerm]);

  const navigate = useNavigate();
  const handleResetFilters = () => {
    setSearchTerm("");
    navigate(`/job-openings`, { replace: false });
  };

  const handleResetFiltersCandidates = () => {
    setSearchTermCandidates("");
  };

  interface JobOpeningFilters {   
      searchTerm: string | null;
      currentPage?: number;
      }
  
  const defaultJobOpeningFilters: JobOpeningFilters = {
    searchTerm: null,
    currentPage: 1,
  };
  
  const areJobOpeningFiltersDefault = (filters: JobOpeningFilters) => {
    return (
      (!filters.searchTerm || filters.searchTerm.trim() === "") &&
      (filters.currentPage ?? 1) === defaultJobOpeningFilters.currentPage
    );
  };
  
      useEffect(() => {
          if (encryptedQuery) {
            try {
              const decoded = decodeURIComponent(encryptedQuery);
              const result = decryptQuery(decoded);
        
              if (result && typeof result === 'object') {
                const data = result as JobOpeningFilters;
        
                setSearchTerm(data.searchTerm || "");
                setCurrentPage(data.currentPage ?? 1);
                return;
              }
            } catch (e) {
              console.warn("Failed to decrypt attendance query:", e);
            }
          }
          // Fallback if no encrypted query or decryption fails
          setSearchTerm("");;
        }, [encryptedQuery]);
  
        const updateFilterUrl = (
          filters: JobOpeningFilters,
          baseRoute: string = "/job-openings"
        ) => {
          if (areJobOpeningFiltersDefault(filters)) {
            navigate(baseRoute, { replace: false });
          } else {
            const encrypted = encryptQuery(filters);
            const encoded = encodeURIComponent(encrypted);
            navigate(`${baseRoute}/${encoded}`, { replace: false });
          }
        };
        useEffect(() => {
            // Call updateFilterUrl with the current search term whenever it changes
            updateFilterUrl({
              searchTerm: debouncedSearchTerm || null,
              currentPage
            });
        }, [debouncedSearchTerm, currentPage]);

  const filtersNode = useMemo(
      () => (
        <JobOpeningFilters
          onResetFilters={handleResetFilters}
          searchTerm={searchTerm}
          onSearchTermChange={(val) => {
            setSearchTerm(val);
            setCurrentPage(currentPage);
          }}
          onAdd={() => openModal("add")}
        />
      ),
      [
        searchTerm,
      ]
    );
  
    useEffect(() => {
      setFilters(filtersNode);
      return () => {
        setFilters(null);
      };
  }, [filtersNode]);

  // open modal (add or edit)
  const openModal = (mode: ModalMode, rec?: JobOpeningType) => {
    setFormError({});
    setModalMode(mode);
    setFormData({
      job_profile: "",
        job_description: "",
        required_experience_min_years: null,
        required_experience_max_years: null,
        job_location: "",
        status: "active",
    });
    setEditId(null);

    if (mode === "edit" && rec) {
      setFormData({
        job_profile: rec.job_profile,
        job_description: rec.job_description,
        required_experience_min_years: rec.required_experience_min_years,
        required_experience_max_years: rec.required_experience_max_years,
        job_location: rec.job_location,
        status: rec.status,
      });
      setEditId(rec.id);
    }

    const el = document.getElementById("payheader_modal");
    if (el) {
      const bsModal = (window as any).bootstrap.Modal.getOrCreateInstance(el);
      bsModal.show();
    }
  };

  // hide modal + backdrop cleanup
  const hideModal = (modalId: string) => {
    const el = document.getElementById(modalId);
    if (!el || !(window as any).bootstrap?.Modal) return;

    const instance = (window as any).bootstrap.Modal.getInstance(el);
    if (instance) {
      instance.hide();
    }

    // after fade, remove any stray backdrops & body locks
    setTimeout(() => {
      document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
    }, 300);
  };

  // Handlers
  const handleAddInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (value.trim() !== "") {
      setFormError((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async () => {
    const errors: any = {};
    console.log("Form data:", formData);
    if (!formData.job_profile.trim())
      errors.job_profile = "Job Profile is required.";
    if (!formData.job_description.trim())
      errors.job_description = "Job Description is required.";

    const min = formData.required_experience_min_years;
    const max = formData.required_experience_max_years;

    if (min == null || max == null) {
      errors.required_experience = "Experience is required.";
    } 
    else if (isNaN(min) || isNaN(max)) {
      errors.required_experience = "Experience values must be numbers.";
    } 
    else if (min < 0 || max < 0) {
      errors.required_experience = "Experience cannot be negative.";
    } 
    else if (min > max) {
      errors.required_experience = "Min years cannot be greater than max years.";
    } 
    else if (min === max) {
      errors.required_experience = "Min and Max years cannot be the same.";
    }

    if (!formData.job_location.trim())
      errors.job_location = "Job Location is required.";

    if (Object.keys(errors).length > 0) {
      setFormError(errors);
      return;
    }
    try {
      const body: Record<string, any> = {
        job_profile: formData.job_profile.trim(),
        job_description: formData.job_description.trim(),
        required_experience_min_years: formData.required_experience_min_years,
        required_experience_max_years: formData.required_experience_max_years,
        job_location: formData.job_location.trim(),
        status: formData.status.trim(),
      };
      if (modalMode === "edit" && editId != null) body.id = editId;
      const res = await nodeApi<{ success: boolean; data: any; error?: string }>(
        "/job-openings/save-job-opening",
        {
          method: "POST",
          body,
        }
      );
      if (res.success) {
        if (modalMode === "edit") {
        await fetchJobOpenings();
        } else {
          // For add mode:
          setTotalItems((prevCount) => {
                const newCount = prevCount + 1;
                setCurrentPage(1);
                fetchJobOpenings();
                return newCount;
              });
        }

        hideModal("payheader_modal");
        toast.success(
          modalMode === "add"
            ? "Job opening added successfully!"
            : "Job opening updated successfully!"
        );
      } 
    } catch (err: any) {
                const backendMessage = err?.response?.data?.message;
                console.error("Error:", backendMessage);
                toast.error(backendMessage || "API failed");
    }
  };

  const handleDelete = async (id: number) => {
    try {
      const res = await nodeApi<any>(
        `/job-openings/delete-job-opening/${id}`,
        { method: "DELETE"}
      );
      if (res.success) {
        setTotalItems((prevCount) => prevCount - 1);
        toast.success("Job opening deleted successfully!");
        // Calculate the total pages after deletion
        const totalPages = Math.ceil((totalItems - 1) / pageSize);
        // If the current page number is now greater than totalPages, move back one page
        if (currentPage > totalPages) {
          setCurrentPage(totalPages > 0 ? totalPages : 1);
        } else {
          await fetchJobOpenings();
        }
      } else {
        toast.error(res.error || "Failed to delete job opening.");
      }
    } catch (err: any) {
                const backendMessage = err?.response?.data?.message;
                console.error("Error:", backendMessage);
                toast.error(backendMessage || "API failed");
    }
  };

  const handleBlur = (
    e: React.FocusEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    if (value.trim() === "") {
      const label =
        name
          .split("_")
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" ");
      setFormError((prev) => ({
        ...prev,
        [name]: `${label} is required.`,
      }));
    }
  };

  const openDeleteModal = (id: number) => {
    setDeleteId(id);
    const modalElement = document.getElementById("top-modal");
    if (modalElement) {
      const modalInstance = (window as any).bootstrap.Modal.getOrCreateInstance(
        modalElement
      );
      modalInstance.show();
    }
  };

  const fmtMonths = (m?: number) => {
    const n = Number(m) || 0;
    const y = Math.floor(n / 12);
    const r = n % 12;
    if (y && r) return `${y} year${y>1?'s':''} ${r} month${r>1?'s':''}`;
    if (y)      return `${y} year${y>1?'s':''}`;
    return `${r} month${r!==1?'s':''}`;
  };

  const handleScheduleInterview = (job: JobOpeningType) => {
    setInterviewMode("schedule");
    setShowLoadCandidateModal(false);
    setSelectedJob(job);
    setShowInterviewModal(true);
  };

  const handleLoadInterview = (job: JobOpeningType) => {
    setInterviewMode("load");
    setSelectedJob(job);
    setShowLoadCandidateModal(true); 
    setSelectedCandidate(null)
  };

  const columns = [
    {
    title: "Job Profile",
    dataIndex: "job_profile",
    width: 180,
    ellipsis: true,
    render: (t: string) => t || "-",
  },
  {
    title: "Job Description",
    dataIndex: "job_description",
    width: 280,
    ellipsis: true,
    render: (html: string) => {
      const text = html
        .replace(/<[^>]+>/g, " ")
        .replace(/&nbsp;/g, " ")
        .replace(/\s+/g, " ")
        .trim();
      return <span title={text}>{text}</span>;
    },
  },
  {
    title: "Experience Required",
    dataIndex: "required_experience_min_years",
    width: 180,
    render: (_: any, record: any) => {
      const min = record.required_experience_min_years;
      const max = record.required_experience_max_years;

      if (min == null || max == null) return "-";

      return `${min}-${max} years`;
    },
  },
  {
    title: "Job Location",
    dataIndex: "job_location",
    width: 180,
    ellipsis: true,
    render: (t: string) => t || "-",
  },
  {
    title: "Created On",
    dataIndex: "created_at",
    width: 180,
    render: (date: string) =>
      date ? dayjs(date).format("DD-MMM-YYYY, h:mm A") : "-",
  },
  {
    title: "Status",
    dataIndex: "status",
    width: 120,
    align: "center",
    render: (status: string) =>
      status === "active" ? (
        <span style={{
              background: "#9FF4C4",
              color: "#34714E",
              padding: "2px 6px",
              borderRadius: "4px",
              width: "80px",
              textAlign: "center",
              height: "20px",
              lineHeight: "17px",
              display: "inline-block",
            }}>Active</span>
      ) : (
        <span style={{
              background: "#FF060661",
              color: "#C24242",
              padding: "2px 6px",
              borderRadius: "4px",
              width: "80px",
              textAlign: "center",
              height: "20px",
              lineHeight: "17px",
              display: "inline-block",
            }}>Inactive</span>
      ),
  },
  {
  title: "Interview",
  dataIndex: "interview",
  width: 300,
  align: "center",
  render: (_: any, rec: JobOpeningType) => {
    const isInactive = rec.status === "inactive" || !!rec.deleted_at;

    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ gap: "8px", flexWrap: "nowrap" }}
      >
        <button
          className="btn btn-sm btn-outline-primary"
          style={{ padding: "2px 6px", lineHeight: "1.2", fontSize: "0.8rem" }}
          onClick={() => !isInactive && handleScheduleInterview(rec)}
          disabled={isInactive}
        >
          Add Candidate
        </button>

        <button
          className="btn btn-sm btn-outline-primary"
          style={{ padding: "2px 6px", lineHeight: "1.2", fontSize: "0.8rem" }}
          onClick={() => !isInactive && handleLoadInterview(rec)}
          disabled={isInactive}
        >
          Load Candidate
        </button>
      </div>
    );
  },
},
  {
    title: "Action",
    dataIndex: "actions",
    width: 80,
    align: "center",
    render: (_: any, rec: JobOpeningType) => {
  const isSoftDeleted = !!rec.deleted_at;

  return (
    <div
      className="action-icon d-inline-flex"
      style={{ opacity: isSoftDeleted ? 0.4 : 1 }}
    >
      <Link
        to="#"
        onClick={isSoftDeleted ? undefined : () => openModal("edit", rec)}
        style={{ pointerEvents: isSoftDeleted ? "none" : "auto" }}
      >
        <i className="ti ti-edit" />
      </Link>

      <Link
        to="#"
        onClick={isSoftDeleted ? undefined : () => openDeleteModal(rec.id)}
        style={{ pointerEvents: isSoftDeleted ? "none" : "auto" }}
      >
        <i className="ti ti-trash" />
      </Link>
    </div>
  );
},
  },
  ];

  const handleSuccess = () => {
    toast.success("Interview scheduled successfully!");
  };

  const handleCloseModal = () => {
    setSelectedJob(null);
    setShowInterviewModal(false);
  };

  return (
    <>
    <div className="page-wrapper d-flex flex-column">
      <div className="content flex-grow-1 " >
        <div className="card card-margin-bottom" ><div className="card-body p-0" id="payheader-list" style={{ height: tableHeight, display: "flex", flexDirection: "column" }}>
        <Table  style={{ flex: 1 }} loading={loading} currentPage={currentPage} dataSource={jobOpening} columns={columns} onPageChange={setCurrentPage} totalItems={totalItems} pageSize={pageSize} />
      </div></div></div>

      {/* Add-Edit Modal */}
      <div className="modal fade" id="payheader_modal">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {modalMode === "add" ? "Add Job Opening" : "Edit Job Opening"}
              </h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => hideModal("payheader_modal")}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body pb-0">
              <div className="mb-3">
                <label className="form-label">
                  Job Profile <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="job_profile"
                  onChange={handleAddInputChange}
                  value={formData.job_profile}
                />
                {formError.job_profile && (
                  <small className="text-danger">{formError.job_profile}</small>
                )}
              </div>
              <JobDescriptionField
                formData={formData}
                formError={formError}
                handleBlur={handleBlur}
                setFormData={setFormData}
                setFormError={setFormError}
              />
              {/* Required Experience (min–max years) */}
              <div className="mb-3">
                <label className="form-label">
                  Experience Required <span className="text-danger">*</span>
                </label>
                <div className="d-flex gap-2">

                  {/* Min Years Input */}
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  className="form-control"
                  placeholder="Min Years"
                  value={
                    formData.required_experience_min_years !== null &&
                    formData.required_experience_min_years !== undefined
                      ? formData.required_experience_min_years.toString()
                      : ""
                  }
                  onChange={(e) => {
                    const val = e.target.value;
                    if (!/^\d*$/.test(val)) return; // only digits

                    setFormData((s) => ({
                      ...s,
                      required_experience_min_years: val === "" ? null : parseInt(val, 10),
                    }));

                    setFormError((prev) => ({
                      ...prev,
                      required_experience: "",
                    }));
                  }}
                />

                {/* Max Years Input */}
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  className="form-control"
                  placeholder="Max Years"
                  value={
                    formData.required_experience_max_years !== null &&
                    formData.required_experience_max_years !== undefined
                      ? formData.required_experience_max_years.toString()
                      : ""
                  }
                  onChange={(e) => {
                    const val = e.target.value;
                    if (!/^\d*$/.test(val)) return;

                    setFormData((s) => ({
                      ...s,
                      required_experience_max_years: val === "" ? null : parseInt(val, 10),
                    }));

                    setFormError((prev) => ({
                      ...prev,
                      required_experience: "",
                    }));
                  }}
                />
                </div>

                {/* Error Messages */}
                {formError.required_experience && (
                  <small className="text-danger d-block mt-1">
                    {formError.required_experience}
                  </small>
                )}

                {/* Display formatted experience */}
                <small className="text-muted d-block mt-1">
                  {
                  formData.required_experience_min_years != null &&
                  formData.required_experience_max_years != null
                    ? `${formData.required_experience_min_years}-${formData.required_experience_max_years} years`
                    : ""}
                </small>
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Job Location <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="job_location"
                  onChange={handleAddInputChange}
                  value={formData.job_location}
                />
                {formError.job_location && (
                  <small className="text-danger">{formError.job_location}</small>
                )}
              </div>
            </div>
            <div className="mb-3">
            <div className="form-check ms-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="status"
                name="status"
                checked={formData.status === "active"}
                onChange={(e) =>
                  setFormData((s) => ({
                    ...s,
                    status: e.target.checked ? "active" : "inactive",
                  }))
                }
              />
              <label className="form-check-label form-label" htmlFor="status">
                Active
              </label>
            </div>
          </div>
            <div className="modal-footer">
              <button
                className="btn btn-light me-2"
                onClick={() => hideModal("payheader_modal")}
              >
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleSubmit}>
                {editId ? "Update" : "Add"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div id="top-modal" className="modal fade" tabIndex={-1}>
        <div className="modal-dialog modal-top">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Delete Job Opening</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete this job opening?</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-cancel" data-bs-dismiss="modal">
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={() => deleteId !== null && handleDelete(deleteId)}
                data-bs-dismiss="modal"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Candidate Modal */}
      {showLoadCandidateModal && (
        <div
          className="modal fade show d-block"
          tabIndex={-1}
          role="dialog"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-xl" style={{
            maxHeight: "600px",      // <-- reduces modal height
          }}>
            <div className="modal-content" style={{ height: "600px", display: "flex", flexDirection: "column" }}>

              {/* Header */}
              <div className="modal-header">
                <h5 className="modal-title">Select Candidate</h5>
                <button className="btn-close" onClick={() => {
                  setShowLoadCandidateModal(false);
                  setSelectedCandidate(null); 
                  setCurrentPageCandidates(1); 
                  setSearchTermCandidates("")
                }} />
              </div>

              {/* Body */}
              <div className="modal-body p-0" style={{ overflowY: "hidden", flex: 1 }}>
                <div className="content">
                  <div className="card card-margin-bottom mb-0">
                    <div
                      className="card-body p-0"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden"
                      }}
                    >

                      {/* Search Field (Triggers API) */}
                      <div className="d-flex align-items-center gap-2">
                      {searchTermCandidates.trim() && (
                        <button
                          className="btn add_btn_size btn-outline-primary reset-vendor"
                          onClick={handleResetFiltersCandidates}
                          title="Reset"
                        >
                          <i className="ti ti-refresh" />
                        </button>
                      )}

                      <input
                        type="text"
                        className="form-control flex-grow-1"
                        placeholder="Search by name or email…"
                        value={searchTermCandidates}
                        onChange={(e) => setSearchTermCandidates(e.target.value)}
                      />
                    </div>

                      {/* Table */}
                      <div
                        style={{
                          height: "415px",
                          overflowY: "auto",
                          overflowX: "hidden",
                          display: "flex",
                          flexDirection: "column"
                        }}
                      >
                        <Table
                          style={{ flex: 1 }}
                          loading={loadingCandidates}
                          currentPage={currentPageCandidates}
                          pageSize={12}
                          dataSource={candidates}
                          totalItems={totalItemsCandidates}
                          onPageChange={(page) => setCurrentPageCandidates(page)}
                          columns={[
                            { title: "Name", dataIndex: "name" },
                            { title: "Email", dataIndex: "email" },
                            {
                              title: "Experience",
                              render: (row: Candidate) =>
                                `${Math.floor(row.total_experience_months / 12)}y ${
                                  row.total_experience_months % 12
                                }m`,
                            },
                            {
                              title: "CTC",
                              dataIndex: "ctc_info",
                              render: (val: Candidate) => `${val} LPA`,
                            },
                            { title: "Location", dataIndex: "current_location" },
                          ]}
                          onRowClick={(row) => setSelectedCandidate(row)}
                          selectedRow={selectedCandidate}
                        />
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="modal-footer">
                <button className="btn btn-light me-2" onClick={() => {
                  setShowLoadCandidateModal(false);
                  setSelectedCandidate(null); 
                  setCurrentPageCandidates(1); 
                  setSearchTermCandidates("")
                }}>
                  Cancel
                </button>

                <button
                  className="btn btn-primary"
                  disabled={!selectedCandidate}
                  onClick={() => {
                    setShowLoadCandidateModal(false);
                    setCurrentPageCandidates(1); 
                    setSearchTermCandidates("")
                    setShowInterviewModal(true);
                  }}
                >
                  Proceed
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* Schedule Interview Modal */}
      <ScheduleInterviewModal
      show={showInterviewModal}
      onClose={handleCloseModal}
      jobId={selectedJob?.id ?? 0} 
      jobProfile={selectedJob?.job_profile ?? ""} 
      mode={interviewMode}
      initialData={{
        candidateId: selectedCandidate?.id ?? undefined, // undefined if new candidate
        candidateName: selectedCandidate?.name ?? "",
        candidateEmail: selectedCandidate?.email ?? "",
        totalExperienceMonths: selectedCandidate?.total_experience_months ?? 0,
        currentCTC: selectedCandidate?.ctc_info ?? "",
        expectedCTC: selectedCandidate?.expected_ctc ?? "",
        currentLocation: selectedCandidate?.current_location ?? "",
        resumeFileName: selectedCandidate?.file_name ?? "",
      }}
      onSuccess={handleSuccess}
    />

      <Footer />
    </div>
    <ToastContainer position="top-right" autoClose={3000} /></>
  );
};
export default JobOpenings;
